import {
  Accordion,
  Card,
  Carousel,
  Flex,
  MarkupPreview,
  Row,
  Title,
} from '@wyz/ui';
import { useManageCustomers } from '~/common/api';
import { useApplicationContext, Trans } from '~/common/context';
import { LineLoader } from '~/purchase/components';
// eslint-disable-next-line @wyz/module/no-relative-import
import './carousel.scss';
import { IUserCustomer } from '~/common/types';
import { memo } from 'react';
type Props = {
  customer: IUserCustomer;
  isAdvertOpen: boolean;
  onToggleAdvert: () => void;
};

function AdvertisementSection({
  customer,
  isAdvertOpen,
  onToggleAdvert,
}: Props) {
  const manageCustomer = useManageCustomers({
    getAdverts: {
      args: { customerPublicKey: customer.id },
    },
  });
  const applicationContext = useApplicationContext();
  return (
    <Card>
      {applicationContext.application.userTheme?.banner?.resourcesFormat[0]
        ?.url && (
        <Row className='flex-center p-2 fit-sub-images'>
          <img
            src={
              applicationContext.application.userTheme.banner.resourcesFormat[0]
                .url
            }
          />
        </Row>
      )}
      {!manageCustomer.getAdverts.isSettled && <LineLoader />}
      {manageCustomer.getAdverts.isSuccess &&
        manageCustomer.getAdverts.data.data.length > 0 && (
          <Accordion.Container
            flush
            defaultActiveKey={isAdvertOpen ? '0' : undefined}
            onSelect={onToggleAdvert}
          >
            <Accordion.Item eventKey='0'>
              <Accordion.Header>
                <Title heading='lg' weight='semi-bold'>
                  <Trans i18nKey='app.common.advert.title' />
                </Title>
              </Accordion.Header>
              <Accordion.Body>
                {manageCustomer.getAdverts.data.data.length === 1 ? (
                  <Flex className='fit-sub-images' justifyContent='center'>
                    <MarkupPreview
                      html={manageCustomer.getAdverts.data.data[0].summary}
                    />
                  </Flex>
                ) : (
                  <Carousel className='theme-slider'>
                    {manageCustomer.getAdverts.data.data.map(
                      (advert, index) => {
                        return (
                          <Carousel.Item key={index}>
                            <div className='d-flex justify-content-center align-items-center fit-sub-images w-100 h-100'>
                              <MarkupPreview html={advert.summary} />
                            </div>
                          </Carousel.Item>
                        );
                      },
                    )}
                  </Carousel>
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion.Container>
        )}
    </Card>
  );
}

export default memo(AdvertisementSection);
